import { useRef } from "react";
import { useSetAtom } from "jotai";
import { useSyncZslStreamToOutline } from "@zapier/streaming/src/hooks/useSyncZslStreamToOutline";
import {
  isViewOnlyModeAtom,
  streamingProgressAtom,
} from "@zapier/canvas-state";

export const useSubmitAndWait = (config: {
  api: string;
  onError?: (error: string) => void;
}) => {
  const setStreamingProgress = useSetAtom(streamingProgressAtom);
  const setIsViewOnlyMode = useSetAtom(isViewOnlyModeAtom);

  const promiseRef = useRef<{
    resolve: (value: unknown) => void;
    reject: (reason?: any) => void;
  } | null>(null);

  const { handleSubmit } = useSyncZslStreamToOutline({
    api: config.api,
    async onComplete(zsl: any) {
      setStreamingProgress(0);
      setIsViewOnlyMode(false);

      if (promiseRef.current) {
        promiseRef.current.resolve(zsl);
        promiseRef.current = null;
      }
    },
    onError(error: string) {
      if (config.onError) {
        config.onError(error);
      }
      if (promiseRef.current) {
        promiseRef.current.reject(error);
        promiseRef.current = null;
      }
    },
  });

  const submitAndWait = (prompt: string) => {
    return new Promise((resolve, reject) => {
      promiseRef.current = { resolve, reject };
      handleSubmit(prompt);
    });
  };

  return submitAndWait;
};
